import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { AppShellChrome } from "../components/AppShellChrome";
import api, { type ApiResponse } from "../services/api";
import { recordPublicPageView } from "../services/publicTrafficBeacon";

/* =========================================================
   OPENAPPCART SHARED PUBLIC SHELL
   See Frontend/DESIGN_CONSTITUTION.md (Response 38)
   Locked logo + menu: AppShellChrome + shared-shell.css
   Homepage middle content: response-27.css — DO NOT MODIFY
   ========================================================= */

export function PublicLayout() {
  const location = useLocation();
  const isHomeBenchmark = location.pathname === "/";
  const isInstallGuide = location.pathname.startsWith("/app-installation-guide");
  const isMembership = location.pathname === "/membership";
  const isSignIn = location.pathname === "/sign-in";
  const isLogIn = location.pathname === "/log-in";
  const isPublishYourApp =
    location.pathname === "/publish-your-app" ||
    location.pathname.startsWith("/publish-your-app/");
  const isDiscoverApps =
    location.pathname === "/discover-apps" ||
    location.pathname.startsWith("/discover-apps/") ||
    location.pathname === "/categories" ||
    location.pathname.startsWith("/categories/");
  const [maintenanceMessage, setMaintenanceMessage] = useState<string | null>(null);

  useEffect(() => {
    recordPublicPageView(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    api
      .get<ApiResponse<{ maintenance: { enabled: boolean; message: string } }>>(
        "/marketplace/platform-status",
      )
      .then((response) => {
        const maintenance = response.data.data.maintenance;
        setMaintenanceMessage(maintenance.enabled ? maintenance.message : null);
      })
      .catch(() => setMaintenanceMessage(null));
  }, []);

  if (maintenanceMessage) {
    return (
      <div className="oac-founder-login">
        <article className="oac-founder-login__card">
          <p className="oac-founder-login__heading">{maintenanceMessage}</p>
        </article>
      </div>
    );
  }

  return (
    <div
      className={[
        "oac-app-shell",
        "oac-public-layout",
        "oac-app-shell--master-shell",
        isHomeBenchmark ? "oac-app-shell--home-benchmark" : "",
        isInstallGuide ? "oac-app-shell--install-guide" : "",
        isMembership ? "oac-app-shell--membership" : "",
        isSignIn ? "oac-app-shell--sign-in" : "",
        isLogIn ? "oac-app-shell--log-in" : "",
        isPublishYourApp ? "oac-app-shell--publish-your-app" : "",
        isDiscoverApps ? "oac-app-shell--discover-apps" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <AppShellChrome />

      <main
        className={[
          "oac-scrollable-main",
          "oac-main-area",
          "oac-public-layout__main",
        ].join(" ")}
      >
        <div
          className={[
            "container",
            "oac-master-desktop-container",
            isHomeBenchmark ? "oac-home-desktop-container" : "",
            isInstallGuide ? "oac-install-desktop-container" : "",
          ]
            .filter(Boolean)
            .join(" ")}
        >
          <div className="row align-items-center oac-page-stage oac-public-layout__stage">
            <section className="col oac-page-content oac-public-layout__content">
              <Outlet />
            </section>

            <div
              aria-hidden="true"
              className="col-auto oac-master-navigation-spacer"
            />
          </div>
        </div>
      </main>
    </div>
  );
}
